/**
 * WordPress dependencies
 */
import { useMergeRefs } from '@wordpress/compose';
import { forwardRef, useRef } from '@wordpress/element';

/**
 * Internal dependencies
 */
import { ControlWithError } from '../control-with-error';
import CheckboxControl from '../../checkbox-control';
import { jsx as _jsx } from "react/jsx-runtime";
const UnforwardedValidatedCheckboxControl = ({
  required,
  customValidity,
  markWhenOptional,
  ...restProps
}, forwardedRef) => {
  const validityTargetRef = useRef(null);
  const mergedRefs = useMergeRefs([forwardedRef, validityTargetRef]);
  return /*#__PURE__*/_jsx(ControlWithError, {
    required: required,
    markWhenOptional: markWhenOptional,
    ref: mergedRefs,
    customValidity: customValidity,
    getValidityTarget: () => validityTargetRef.current?.querySelector('input[type="checkbox"]'),
    children: /*#__PURE__*/_jsx(CheckboxControl
    // TODO: Upstream limitation - CheckboxControl doesn't support uncontrolled mode, visually.
    , {
      ...restProps
    })
  });
};
export const ValidatedCheckboxControl = forwardRef(UnforwardedValidatedCheckboxControl);